import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer, SurveyPageTitle } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { SessionStat } from "../../common_components/Analytics";
import DownloadButtonRow from "./DownloadButtonRow";


// Api Calls
import MissionAPI from "../../../api/api_calls/MissionAPI";
import SurveyAPI from "../../../api/api_calls/SurveyAPI";

function SurveyResponses(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    const [surveyResponseCount, setSurveyResponseCount] = useState(-1);
    const [goalResponses, setGoalResponses] = useState(-1);
    const [passingScreenerResponses, setPassingScreenerResponses] = useState(-1);
    const [totalScreenerResponses, setTotalScreenerResponses] = useState(-1);
    const [loadingResponses, setLoadingResponses] = useState(true);

    const [submittingSurveyAndScreenerDownload, setSubmittingSurveyAndScreenerDownload] = useState(false);
    const [submittingSurveyDownload, setSubmittingSurveyDownload] = useState(false);


    useEffect(() => {
        async function getCompletedSessionsAndStats() {
            const result = await MissionAPI.showSurveyResponses({ missionId, navigate });

            if (result.success) {
                setSurveyResponseCount(result.survey_responses_count)
                setGoalResponses(result.mission.num_total_spots)
                if (result.total_screener_responses_count > 0) {
                    setPassingScreenerResponses(result.passing_screener_responses_count)
                    setTotalScreenerResponses(result.total_screener_responses_count)
                }

                setLoadingResponses(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getCompletedSessionsAndStats();
    }, []);

    function downloadSurveyAndScreenerCSV() {

        async function downloadCSV() {
            const result = await SurveyAPI.downloadSurveyAndScreener({ missionId, navigate });

            if (result.success) {
                alert.show("Download started", { type: 'success' })
            } else {
                alert.show(result.error, { type: 'error' })
            }
            setSubmittingSurveyAndScreenerDownload(false);
        }
        setSubmittingSurveyAndScreenerDownload(true);
        downloadCSV();
    }

    function downloadSurveyCSV() {
        async function downloadCSV() {
            const result = await SurveyAPI.downloadSurvey({ missionId, navigate });

            if (result.success) {
                alert.show("Download started", { type: 'success' })
            } else {
                alert.show(result.error, { type: 'error' })
            }
            setSubmittingSurveyDownload(false);
        }
        setSubmittingSurveyDownload(true);
        downloadCSV();
    }


    return (
        <>
            <SubHeader title={"Survey Responses"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                <SurveyPageTitle completes={surveyResponseCount} goal={goalResponses} />
                <Card>
                    <GrayCardTitle title="Download Responses" />
                    {totalScreenerResponses > 0 ? <DownloadButtonRow title="Screener and Survey" loading={submittingSurveyAndScreenerDownload} onClick={downloadSurveyAndScreenerCSV} /> : <></>}
                    <DownloadButtonRow title="Survey" loading={submittingSurveyDownload} onClick={downloadSurveyCSV} />
                </Card>
                <Card>
                    <GrayCardTitle title="Survey Stats" />
                    {loadingResponses ? <CenteredLoadingIcon /> :
                        <div className="session-stats-container">
                            <SessionStat title="Completions" primaryFill={surveyResponseCount} goalValue={goalResponses} legendText={surveyResponseCount + " of " + goalResponses} />
                            {totalScreenerResponses > 0 ? <SessionStat title="Screener Pass Rate" primaryFill={passingScreenerResponses} goalValue={totalScreenerResponses} legendText={Math.round(passingScreenerResponses * 1.0 / totalScreenerResponses * 100) + "%"} /> : <></>}
                        </div>
                    }
                </Card>
            </MissionPageContainer>
        </>

    )

}


export default SurveyResponses;